import { BASE_URL } from "../../../api/config";
import { EndpointsE } from "../../../data/endpoints";
import { LangE } from "../../../models/enums";
import { fetchBase64ProfilePhoto } from "../fetchBase64profilePhoto";
import getUserRole from "../getUserRole";
import showErrorToast from "../showErrorToast";
import {
  ClientUserDataReturnT,
  UserDataReturnT,
  FetchUserDataReturnT,
  FetchUserDataReturnUserT,
} from "./models";

const CULTURE_EN = "en-US";

const fetchUserData = async (
  accessToken: string,
  refreshToken: string
): Promise<FetchUserDataReturnT> => {
  let result: FetchUserDataReturnUserT | {} = {};
  let lang = LangE.EN;

  try {
    const rawClientUserData = await fetch(
      `${BASE_URL}${EndpointsE.CLIENTS_GET_USER_INFO}`,
      {
        method: "GET",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const clientUserData: ClientUserDataReturnT =
      await rawClientUserData.json();

    const rawUserData = await fetch(
      `${BASE_URL}${EndpointsE.USERS_USER_GET}${clientUserData.real_id}`,
      {
        method: "GET",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      }
    );

    const userData: UserDataReturnT = await rawUserData.json();

    const profilePhoto: any = await fetchBase64ProfilePhoto(
      clientUserData.Id,
      accessToken
    );
    const role = getUserRole(userData, clientUserData);

    // set user data
    result = {
      AdId: clientUserData.AdId,
      id: clientUserData.Id,
      userId: clientUserData.real_id,
      userName: userData.UserName,
      role,
      clientType: clientUserData.ClientType,
      accessLevel: userData.AccessLevel,
      culture: userData.Culture,
      email: userData.Email,
      EmailConfirmed: userData.EmailConfirmed,
      ContactInfoConfirmed: userData.ContactInfoConfirmed,
      ClientCurrency: clientUserData?.ClientCurrency || 0,
      profilePhoto,
      refreshToken,
    };

    // set language
    lang = (userData.Culture === CULTURE_EN ? LangE.EN : LangE.HE);
  } catch (e) {
    showErrorToast();
    console.log(e);

    return [null, lang];
  }

  return [{ user: result as FetchUserDataReturnUserT }, lang];
};

export default fetchUserData;
